import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractChartOfAccountsValidationResult from "./AbstractChartOfAccountsValidationResult.js";

/**
 * Error raised when a known group points to a group not in the chart of accounts.
 *
 * @param {string} spec.expectedId - Id expected to be found in the chart of accounts
 * @param {string} spec.knownGroupId - Known group pointing to an absent group
 */
export default class EmptyKnownGroupValidationResult extends AbstractChartOfAccountsValidationResult {
	constructor(spec) {
		super(spec);

		this._expectedId = spec.expectedId;
		this._knownGroup = this._chartOfAccounts.findById(spec.knownGroupId);
	}

	getExpectedId() {
		return this._expectedId;
	}

	getKnownGroup() {
		return this._knownGroup;
	}

	getMessage() {
		return _(
			'The known group "{name}" expect the component with id {id} to be found in the chart of accounts.',
			{
				name: this._knownGroup.getName(),
				id: this._expectedId,
			},
		);
	}

	static getType() {
		return "EmptyKnownGroupException";
	}
}
